import endpoints from 'helper/endpoints'
import {fireErrorToast, fireSuccessToast, globalApiErrorHandler} from 'helper/functions'
import httpClient from 'helper/httpClient'
import React from 'react'
import {
  GET_TYPE_OF_WORK_FAIL,
  GET_TYPE_OF_WORK_LIST_FAIL,
  GET_TYPE_OF_WORK_LIST_REQUEST,
  GET_TYPE_OF_WORK_LIST_SUCCESS,
  GET_TYPE_OF_WORK_REQUEST,
  GET_TYPE_OF_WORK_SUCCESS,
} from 'redux/actionType'
import {Trans} from '@lingui/macro'

export const getTypeOfWorkList = (limit = 1000, offset = 0, meta, search) => {
  return (dispatch) => {
    dispatch({type: GET_TYPE_OF_WORK_LIST_REQUEST})
    const searchQuery = search ? `?search=${search}` : ''
    return httpClient
      .get(endpoints.typesOfWork + searchQuery, {
        limit: limit,
        offset: offset,
        order_by:
          meta?.orderBy && meta?.orderDirection && `${meta?.orderBy}:${meta?.orderDirection}`,
      })
      .then((res) => {
        dispatch({type: GET_TYPE_OF_WORK_LIST_SUCCESS, data: res.data})
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        dispatch({type: GET_TYPE_OF_WORK_LIST_FAIL})
        return globalApiErrorHandler(err)
      })
  }
}

export const getTypeOfWork = (id) => {
  return (dispatch) => {
    dispatch({type: GET_TYPE_OF_WORK_REQUEST})
    return httpClient
      .get(endpoints.typesOfWork + '/' + id)
      .then((res) => {
        dispatch({type: GET_TYPE_OF_WORK_SUCCESS, data: res.data})
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        dispatch({type: GET_TYPE_OF_WORK_FAIL})
        globalApiErrorHandler(err)
        return Promise.reject(err?.response?.data?.errors)
      })
  }
}

export const createTypeOfWork = (data) => {
  return (dispatch) => {
    return httpClient
      .post(endpoints.typesOfWork, data)
      .then((res) => {
        fireSuccessToast(<Trans>New type of work created.</Trans>)
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        if (err.response?.status === 422 && err.response?.data?.errors?.length) {
          return Promise.reject(err?.response?.data?.errors)
        } else {
          return globalApiErrorHandler(err)
        }
      })
  }
}

export const patchTypeOfWork = (id, data) => {
  return (dispatch) => {
    return httpClient
      .patch(endpoints.typesOfWork + '/' + id, data)
      .then((res) => {
        fireSuccessToast(<Trans>Type of work updated.</Trans>)
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        if (err.response?.status === 422 && err.response?.data?.errors?.length) {
          return Promise.reject(err?.response?.data?.errors)
        } else {
          return globalApiErrorHandler(err)
        }
      })
  }
}
